import { format, addDays, startOfDay, parseISO } from 'date-fns';
import type { Locale } from 'date-fns';

/**
 * Format a time slot for display
 */
export const formatTimeSlot = (from: string, to: string, showDuration: boolean = false): string => {
  const fromTime = from.substring(11, 16);

  if (showDuration) {
    const toTime = to.substring(11, 16);
    return `${fromTime} - ${toTime}`;
  }

  return fromTime;
};

/**
 * Format a reservation ISO datetime's calendar date for display.
 * Uses the date part from the string (store wall-clock) so evening/overnight
 * slots are not shifted to the next day by the browser timezone.
 */
export const formatReservationDate = (
  isoDateTime: string,
  formatStr: string,
  locale?: Locale
): string => {
  const datePart = isoDateTime.substring(0, 10);
  return format(parseISO(datePart), formatStr, { locale });
};

/**
 * Format date to YYYY-MM-DD for API
 */
export const formatDateForApi = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

/**
 * Get min and max dates for date picker based on constraints
 */
export const getDateConstraints = (minOffset: number = 0, maxOffset: number = 90) => {
  const today = startOfDay(new Date());
  return {
    minDate: addDays(today, minOffset),
    maxDate: addDays(today, maxOffset),
  };
};

/**
 * Check if a date is valid for booking
 */
export const isDateValid = (date: Date, minOffset: number = 0, maxOffset: number = 90): boolean => {
  const { minDate, maxDate } = getDateConstraints(minOffset, maxOffset);
  const dateToCheck = startOfDay(date);
  return dateToCheck >= minDate && dateToCheck <= maxDate;
};
